import React from 'react'
import BlockQuote from './block-quote'
import BlockImgText from './block-img-text'
import BlockImgTextSpan from './block-img-text-span'
import BlockImgTextNumber from './block-img-text-number'
import BlockTextNumber from './block-text-number'
import BlockTimeline from './block-timeline'
import BlockText from './block-text'
import BlockGallery from './block-gallery'
import BlockNumberList from './block-number-list'
import BlockNumberQuote from './block-number-quote'
import BlockTable from './block-table'
import BlockComparisonTable from './block-comparison-table'
import BlockTextContentScroll from './block-text-content-scroll'
import BlockAccordion from './block-accordion'
import BlockTextHalf from './block-text-half'
import BlockResource from './block-resource'

const blocksRef = {
  'BlockQuote': BlockQuote,
  'BlockImgText': BlockImgText,
  'BlockImgTextSpan': BlockImgTextSpan,
  'BlockImgTextNumber': BlockImgTextNumber,
  'BlockTimeline': BlockTimeline,
  'BlockText': BlockText,
  'BlockGallery': BlockGallery,
  'BlockNumberList': BlockNumberList,
  'BlockNumberQuote': BlockNumberQuote,
  'BlockTextNumber': BlockTextNumber,
  'BlockTable': BlockTable,
  'BlockComparisonTable': BlockComparisonTable,
  'BlockTextContentScroll': BlockTextContentScroll,
  'BlockAccordion': BlockAccordion,
  'BlockTextHalf': BlockTextHalf,
  'BlockResource': BlockResource
}

const getBlocks = (blocks) => {
  return blocks.map((block, i) => {
    const Co = blocksRef[block.component]
      return <Co key={i} data={block}/>
  })
}

const DynamicBlocks = ({data}) => {
  return (getBlocks(data))
}

export default DynamicBlocks
